module.exports = __webpack_public_path__ + "media/images/diy/bg-shape-3-62866953c3bb6855781473baeeec5902.svg";